import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import { applyHooks } from 'src/router/hooks'
import { addRoutes } from '../modules'
import routes from './routes'

export type RouteRecord = RouteRecordRaw & {
  noLayout?: boolean
}

export type RouteRecords = RouteRecord[]

export default async () => {
  const router = createRouter({
    scrollBehavior: () => ({ left: 0, top: 0 }),
    routes,
    history: createWebHistory(import.meta.env.VUE_ROUTER_BASE),
  })

  await addRoutes(router)
  applyHooks(router)

  return router
}
